import React from 'react';
import { StyleSheet } from 'react-native';

import { useResizeImage } from '@/components/player-profile/hooks/use-resize-image.web';
import { CONTAINER_SIZE } from '@/feature/player-profile-sheets/utils/player-profile-utils';

export const ProfileImageSilhouette = ({ source, onError }: { source: string; onError: (error: unknown) => void }) => {
    const image = useResizeImage({ source });

    return <>{image ? <img src={image} alt="" style={styles.img} onError={onError} /> : null}</>;
};

const styles = StyleSheet.create({
    img: {
        width: CONTAINER_SIZE.width,
        height: CONTAINER_SIZE.height,
        filter: 'brightness(0) saturate(6%) invert(8%) opacity(0.8)',
    },
});
